/** Carvago logo color, independent of the active workspace accent. */
export const CARVAGO_BRAND_COLOR = '#3E47DD';
